import moment from 'moment';

export default {
    methods: {
        formatTimeDiff(date, format = 'MMM-DD-YY') {
            const newDate = new Date(date);
            if(newDate) {
                const currentDate = moment();
                const targetDate = moment(newDate, format);

                const years = currentDate.diff(targetDate, 'years');
                targetDate.add(years, 'years');

                const months = currentDate.diff(targetDate, 'months');
                targetDate.add(months, 'months');

                const days = currentDate.diff(targetDate, 'days');

                // return `${years}yr - ${months}mo - ${days}d`;
              return `<span style="color: #428bca;">${years}yr</span> - <span style="color: #93c47d;">${months}mo</span> - ${days}d`;

            }
            return ""
        },
        formatDate(date) {
            const months = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const parsedDate = new Date(date);

            return `${months[parsedDate.getMonth()]}-${parsedDate.getDate()}-${parsedDate.getFullYear().toString().substr(-2)}`;

        }
    }
}
